import styled from '@emotion/styled'

export const SearchWrapper = styled.div`
  width: 100%;
`
